import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import scrollToComponent from 'utils/scrollToComponent';

import {
  closeBazaarDialog,
  fetchAvailableItems,
  fetchExchange,
  openBazaarDialog,
  selectStore,
} from 'actions/exchange';

import getQuantities from 'selectors/exchange/getQuantities';
import getShopList from 'selectors/exchange/getShopList';

import Loading from 'components/Loading';

import BazaarUnavailableMessage from './components/BazaarUnavailableMessage';
import BazaarDialog from './components/BazaarDialog';
import ExchangeComponent from './ExchangeComponent';

class ExchangeContainer extends Component {
  state = {
    filterString: '',
  }

  /**
   * Component Did Mount
   * @return {undefined}
   */
  componentDidMount = () => {
    const { activeStore, dispatch, isFetchingAvailable } = this.props;
    // Don't fetch while fetching
    if (isFetchingAvailable) {
      return;
    }

    // Fetch the exchange, then go get stuff for the active store
    dispatch(fetchExchange())
      .then(() => dispatch(fetchAvailableItems(activeStore)));
  }

  handleJumpToTop = () => {
    // TODO: we probably shouldn't use dqs here (should rely on refs instead)
    const header = document.querySelector('.exchange__title');
    scrollToComponent(header, { offset: 0, align: 'top' });
  }

  handleSearchFieldChange = (evt) => {
    this.setState({ filterString: evt.currentTarget.value });
  }

  /**
   * Handle store select
   * @param  {Number} storeId
   * @return {Undefined}
   */
  handleStoreSelect = (se) => {
    const { dispatch } = this.props;

    // We may be passed either a store object or an event,
    // because we might be coming here from either the sticky menu
    // (on large displays) or the select menu (on small ones)
    if (typeof se === 'object' && se !== null) {
      if ('id' in se) {
        if (se.id === 'jump-to-top') {
          return this.handleJumpToTop();
        }
        return dispatch(selectStore(se.id));
      }
      // If we can't parse the target as an integer, coerce it to null
      // (a non-integer shop ID means 'Sell my things')
      return dispatch(selectStore(parseInt(se.target.value, 10) || null));
    }
    return undefined;
  }

  /**
   * Open Bazaar dialog
   * @param  {Object} item
   * @return {undefined}
   */
  openBazaarDialog = (item) => {
    const { dispatch } = this.props;
    dispatch(openBazaarDialog(item));
  }

  /**
   * closeDialog
   * @return {undefined}
   */
  closeBazaarDialog = () => {
    const { dispatch } = this.props;
    dispatch(closeBazaarDialog());
  }

  render() {
    const {
      activeItem,
      exchangeData,
      isAvailable,
      isFetching,
      quantities,
      shopList,
    } = this.props;

    const {
      filterString,
    } = this.state;

    if (isFetching) {
      return <Loading />;
    }

    if (!isAvailable) {
      return <BazaarUnavailableMessage />;
    }

    return (
      <Fragment>
        <ExchangeComponent
          filterString={filterString}
          onSearchFieldChange={this.handleSearchFieldChange}
          onStoreSelect={this.handleStoreSelect}
          quantities={quantities}
          shopList={shopList}
        />
        {activeItem && (
          <BazaarDialog
            data={exchangeData}
            quantities={quantities}
            onRequestClose={this.closeBazaarDialog}
          />
        )}
      </Fragment>
    );
  }
}

ExchangeContainer.displayName = 'ExchangeContainer';

ExchangeContainer.propTypes = {
  activeItem: PropTypes.shape({}),
  activeStore: PropTypes.number,
  dispatch: PropTypes.func.isRequired,
  isAvailable: PropTypes.bool.isRequired,
  isFetchingAvailable: PropTypes.bool.isRequired,
  isFetching: PropTypes.bool.isRequired,
  exchangeData: PropTypes.shape({}).isRequired,
  quantities: PropTypes.shape({}).isRequired,
  shopList: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
};

ExchangeContainer.defaultProps = {
  activeItem: null,
  activeStore: null, // 'Sell my things' is null
};

const mapStateToProps = (state) => {
  const { exchange } = state;
  const {
    activeItem,
    activeStore,
    isAvailable,
    isFetching,
    isFetchingAvailable,
    data: exchangeData,
  } = exchange;
  return {
    activeItem,
    activeStore,
    exchangeData,
    isAvailable,
    isFetching,
    isFetchingAvailable,
    quantities: getQuantities(state),
    shopList: getShopList(state),
  };
};

export default connect(mapStateToProps)(ExchangeContainer);